import AdobeAnalyticsButtonTags from "../../constants/AdobeAnalyticsButtonTags";
import constants from "../constants";
import { getValidCountryDropdownOptionsIntl } from "../CountryConfigurations";
import intlConstants from "../intlConstants";

const FormConfig = {
  sections: [
    {
      section: {
        id: 0,
        title: "",
        isActive: true,
        stepperNumber: 1,
        stepperLabel: "Country"
      },
      fields: [
        {
          class: "field_group_label padding_top_5",
          containerClass: "text_center width_100",
          id: "",
          label: "In which country is your company registered?",
          labelClass: "custom_size",
          name: "",
          type: constants.INPUT_TYPE_LABEL,
          customHandler: "renderPhoneCountryCode"
        },
        {
          class: " registration_country width_50",
          containerClass: "width_50",
          dataSource: "",
          default: "",
          fakeValue: "",
          id: "registrationCountry",
          label: "In which country is your company registered?",
          labelClass: "",
          labelDescription: "",
          name: "registrationCountry",
          options: getValidCountryDropdownOptionsIntl,
          placeHolder: "Select your country",
          required: true,
          type: constants.INPUT_TYPE_THUMBNAILDROPDOWN,
          validators: [
            {
              type: constants.VALIDATOR_NOT_EMPTY,
              errorMessage: "Select a country"
            }
          ]
        }
      ]
    },
    {
      section: {
        id: 1,
        title: "Business information",
        isActive: true,
        stepperNumber: 1,
        stepperLabel: "Business",
        itShouldHideAccordionNavigators: true,
        validators: []
      },
      fields: [
        {
          class: "",
          containerClass: "",
          dataSource: "",
          default: "",
          fakeValue: "",
          id: "fantasyName",
          label: "Commercial Name or Fantasy Name",
          labelEn: "Commercial Name or Fantasy Name",
          labelClass: "",
          labelDescription: "",
          name: "fantasyName",
          options: [],
          order: 2,
          placeHolder: "E.g. MyStore",
          regex: "",
          required: true,
          type: constants.INPUT_TYPE_TEXT,
          maxLength: "80",
          validators: [
            {
              type: constants.VALIDATOR_NOT_EMPTY,
              errorMessage: "Enter a Commercial name or fantasy name"
            },
            {
              type: constants.VALIDATOR_REGEX,
              errorMessage: "Enter a name without special characters.",
              data: {
                regex: /^[\w ]+[a-zA-Z0-9.&,']+$/
              }
            }
          ]
        },
        {
          class: "",
          containerClass: "",
          dataSource: "",
          default: "",
          fakeValue: "",
          id: "shopName",
          label: "Legal name / Company Name",
          labelEn: "Legal name / Company Name",
          labelClass: "",
          labelDescription: "",
          name: "shopName",
          options: [],
          order: 1,
          placeHolder: "E.g. MyStore Inc.",
          regex: "",
          required: true,
          type: constants.INPUT_TYPE_TEXT,
          maxLength: "80",
          validators: [
            {
              type: constants.VALIDATOR_NOT_EMPTY,
              errorMessage: "Enter a Legal name/Company name"
            },
            {
              type: constants.VALIDATOR_REGEX,
              errorMessage: "Enter a name without special characters.",
              data: {
                regex: /^[\w ]+[a-zA-Z0-9.&,']+$/
              }
            }
          ]
        },
        {
          class: "",
          containerClass: "",
          dataSource: "",
          default: "",
          fakeValue: "",
          id: constants.INPUT_ID_BUSSINESS_REG_NUMBER,
          label: "Business Registration Number",
          labelEn: "Business Registration Number",
          labelClass: "",
          labelDescription: "",
          name: constants.INPUT_ID_BUSSINESS_REG_NUMBER,
          options: [],
          order: 1,
          placeHolder: "E.g. 011223344",
          regex: "",
          required: true,
          type: constants.INPUT_TYPE_TEXT,
          maxLength: "50",
          customHandler: constants.VALIDATE_BASED_ON_COUNTRY,
          validators: [
            {
              type: constants.VALIDATOR_NOT_EMPTY,
              errorMessage: "This field is required, enter the Business Registration Number."
            },
            {
              type: constants.VALIDATOR_MIN_LENGTH,
              errorMessage: "Business Registration Number must be at least 5 characters long.",
              data: {
                minLength: 5
              }
            }
          ]
        },
        {
          class: "",
          containerClass: "",
          dataSource: "",
          default: "",
          fakeValue: "",
          id: "companyDocumentType",
          label: "Business Document type",
          labelEn: "Business Document type",
          labelClass: "",
          labelDescription: "",
          name: "companyDocumentType",
          placeHolder: "Select an option",
          options: [
            {
              id: "companyDocumentType_0",
              label: "Select an option",
              value: ""
            },
            {
              id: "companyDocumentType_1",
              label: "Business License",
              value: "BL"
            },
            {
              id: "companyDocumentType_2",
              label: "Certificate of Registration",
              value: "CR"
            },
            {
              id: "companyDocumentType_3",
              label: "Tax Registry",
              value: "TR"
            }
          ],
          required: false,
          type: constants.INPUT_TYPE_DROPDOWN,
          validators: [
            {
              type: constants.VALIDATOR_NOT_EMPTY,
              errorMessage: "Select an option."
            }
          ]
        },
        {
          class: "",
          containerClass: "",
          dataSource: "",
          id: "documentBusinessRegistration",
          label: "Business Document",
          labelEn: "Business Document",
          labelDescription: "",
          labelClass: "",
          boxDescription: "1 JPG, PNG or PDF file allowed.",
          name: "documentBusinessRegistration",
          type: constants.INPUT_TYPE_FILE,
          required: true,
          attachTextButton: "Attach",
          attachTextLabel: "or drag the file",
          dropTextMessage: "Drop the file into this area",
          accept: ".jpg,.jpeg,.png,.pdf",
          validators: [
            {
              type: constants.VALIDATOR_FILE_SIZE,
              errorMessage: "The file exceeds the allowed limit, it must not exceed 3MB.",
              data: {
                maxAllowedSize: 3e6
              }
            },
            {
              type: constants.VALIDATOR_FILE_TYPE,
              errorMessage: "Invalid file, attach only JPG, PNG or PDF.",
              data: {
                allowedFileTypes: ["jpg", "jpeg", "png", "pdf"]
              }
            },
            {
              type: constants.VALIDATOR_HAS_CURRENT_VALUE,
              errorMessage:
                "You can only upload one file. If you want to attach a different file, you'll need to delete the current one."
            },
            {
              type: constants.VALIDATOR_NOT_EMPTY,
              errorMessage: "Please attach a Business Document file."
            }
          ]
        }
      ]
    },
    {
      section: {
        id: 2,
        title: "People information",
        isActive: true,
        stepperNumber: 2,
        stepperLabel: "People",
        type: "Accordion",
        activeSubSection: "2-1",
        itShouldHideAccordionNavigators: true
      },
      subSections: [
        {
          id: "2-1",
          title: "Legal Representative of the Company",
          subTitle: "",
          enabled: true,
          showNavigation: true,
          navigationButtonId: AdobeAnalyticsButtonTags[2].legal,
          onRenderActions: {
            subTitle: {
              handler: "RenderSubTitle",
              params: {
                renderSubtitleWith: []
              }
            }
          },
          onNavigateActions: {
            next: {
              handler: constants.ACTION_HANDLER_RENDER_SUBTITLE_AND_FOCUS_SUBSECTION,
              params: {
                nextSubSection: "2-2",
                renderSubtitleWith: [constants.INPUT_ID_LEGAL_REPRESENTATIVE_NAME]
              }
            },
            previous: "",
            btnLabel: "Continue"
          },
          autofill: {
            message: "Use this information for all contacts.",
            affectedSections: ["2-2", "2-3"],
            behavior: {
              [constants.INPUT_ID_ADMIN_FIRST_NAME]: constants.INPUT_ID_LEGAL_REPRESENTATIVE_NAME,
              [constants.INPUT_ID_ADMIN_LAST_NAME]: constants.INPUT_ID_LEGAL_REPRESENTATIVE_LASTNAME,
              [constants.INPUT_ID_ADMIN_DOCUMENT_TYPE]: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_TYPE,
              [constants.INPUT_ID_ADMIN_DOCUMENT_NUMBER]: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_NUMBER,
              [constants.INPUT_ID_ADMIN_PHONE]: constants.INPUT_ID_LEGAL_REPRESENTATIVE_PHONE,
              [constants.INPUT_ID_ADMIN_EMAIL]: constants.INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL,
              confirmAdminEmail: "confirmLegalRepEmail",
              [constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_NAME]: [
                constants.INPUT_ID_LEGAL_REPRESENTATIVE_NAME,
                constants.INPUT_ID_LEGAL_REPRESENTATIVE_LASTNAME
              ],
              [constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_PHONE]: constants.INPUT_ID_LEGAL_REPRESENTATIVE_PHONE,
              [constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_EMAIL]: constants.INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL,
              confirmShipmentWarehouseContactEmail: "confirmLegalRepEmail"
            }
          },
          fields: [
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_LEGAL_REPRESENTATIVE_NAME,
              label: "First Name",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_LEGAL_REPRESENTATIVE_NAME,
              placeHolder: "E.g. John",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "49",
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_SPACES,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid name."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_LEGAL_REPRESENTATIVE_LASTNAME,
              label: "Last Name",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_LEGAL_REPRESENTATIVE_LASTNAME,
              placeHolder: "E.g. Smith",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "49",
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_SPACES,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid last name."
                }
              ]
            },
            {
              class: "search-icon",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_DOCUMENT_ISSUING_COUNTRY,
              label: "ID Issuing Country",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              required: true,
              name: constants.INPUT_ID_DOCUMENT_ISSUING_COUNTRY,
              options: intlConstants.COUNTRY_VALIDATIONS,
              placeHolder: "Enter a country",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dataSource: {},
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid country."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_TYPE,
              label: "Identification Document Type",
              labelClass: "",
              labelDescription: "",
              placeHolder: "Select document type",
              name: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_TYPE,
              required: true,
              type: constants.INPUT_TYPE_DROPDOWN,
              options: [
                {
                  id: "DNI",
                  label: "Document Identification",
                  value: "DNI"
                },
                {
                  id: "PAS",
                  label: "Passport",
                  value: "PAS"
                },
                {
                  id: "DL",
                  label: "Drivers License",
                  value: "DL"
                }
              ],
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid document type."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_NUMBER,
              label: "Identification Document Number",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_NUMBER,
              placeHolder: "Enter your Identification Document Number",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_NUMBERS,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid ID number."
                },
                {
                  type: constants.VALIDATOR_DOCUMENT_NUMBER_BY_ISSUING_COUNTRY,
                  errorMessage: "Document number should be between minLength and maxLength characters long.",
                  data: {
                    countryFieldId: "idIssuingCountry",
                    docTypeFieldId: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_TYPE
                  }
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              dataSource: "",
              id: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_FILE,
              label: "Identification Document Image",
              labelClass: "",
              boxDescription: "1 JPG, PNG or PDF file permitted. Max. 3 MB.",
              name: constants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_FILE,
              type: constants.INPUT_TYPE_FILE,
              required: true,
              attachTextButton: "Attach",
              attachTextLabel: "or drag and drop the file",
              dropTextMessage: "Drop file here",
              accept: ".jpg,.jpeg,.png,.pdf",
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Attach a valid document."
                },
                {
                  type: constants.VALIDATOR_FILE_TYPE,
                  errorMessage: "Attach a valid file format, only JPG, PNG or PDF.",
                  data: {
                    allowedFileTypes: ["jpg", "jpeg", "png", "pdf"]
                  }
                },
                {
                  type: constants.VALIDATOR_FILE_SIZE,
                  errorMessage: "Attach a file up to 3 MB.",
                  data: {
                    maxAllowedSize: 3e6
                  }
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_LEGAL_REPRESENTATIVE_PHONE,
              label: "Phone",
              labelDescription: "Include the country code (e.g., 56).",
              labelClass: "",
              name: constants.INPUT_ID_LEGAL_REPRESENTATIVE_PHONE,
              options: [],
              placeHolder: "56930305680",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "15",
              customHandler: constants.INPUT_HANDLER_ONLY_NUMBERS,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid phone."
                },
                {
                  type: constants.VALIDATOR_MAX_LENGTH,
                  errorMessage: "Phone exceeds the maximum of 15 characters allowed",
                  data: {
                    maxLength: 15
                  }
                },
                {
                  type: constants.VALIDATOR_MIN_LENGTH,
                  errorMessage: "Phone must be at least 5 characters long",
                  data: {
                    minLength: 5
                  }
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL,
              label: "Email",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL,
              placeHolder: "E.g. contact@info.com",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_EMAIL,
                  errorMessage: "Enter a valid email."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: "confirmLegalRepEmail",
              label: "Confirm Email",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: "confirmLegalRepEmail",
              placeHolder: "E.g. contact@info.com",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_EMAIL,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_CONFIRMATION_FIELD_VALUE,
                  errorMessage: "The email does not match.",
                  data: {
                    sourceFieldId: constants.INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL
                  }
                }
              ]
            }
          ]
        },
        {
          id: "2-2",
          title: "Account Administration Responsible",
          subTitle: "Will be the primary account contact at Falabella Seller Center.",
          enabled: false,
          showNavigation: true,
          navigationButtonId: AdobeAnalyticsButtonTags[2].administrator,
          onRenderActions: {
            subTitle: {
              handler: "RenderSubTitle",
              params: {
                renderSubtitleWith: []
              }
            }
          },
          onNavigateActions: {
            next: {
              handler: constants.ACTION_HANDLER_RENDER_SUBTITLE_AND_FOCUS_SUBSECTION,
              params: {
                nextSubSection: "2-3",
                renderSubtitleWith: [constants.INPUT_ID_ADMIN_FIRST_NAME, constants.INPUT_ID_ADMIN_LAST_NAME]
              }
            },
            previous: "",
            btnLabel: "Continue"
          },
          autofill: {
            message: "Use this information for shipping warehouse contact.",
            affectedSections: ["2-2", "2-3"],
            behavior: {
              [constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_NAME]: [
                constants.INPUT_ID_ADMIN_FIRST_NAME,
                constants.INPUT_ID_ADMIN_LAST_NAME
              ],
              [constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_PHONE]: constants.INPUT_ID_ADMIN_PHONE,
              [constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_EMAIL]: constants.INPUT_ID_ADMIN_EMAIL,
              confirmShipmentWarehouseContactEmail: "confirmAdminEmail"
            }
          },
          fields: [
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_ADMIN_FIRST_NAME,
              label: "First Name",
              labelEn: "First Name",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_ADMIN_FIRST_NAME,
              placeHolder: "E.g. John",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "49",
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_SPACES,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid name."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_ADMIN_LAST_NAME,
              label: "Last Name",
              labelEn: "Last Name",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_ADMIN_LAST_NAME,
              placeHolder: "E.g. Smith",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "49",
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_SPACES,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid last name."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_ADMIN_DOCUMENT_TYPE,
              label: "Identification Document Type",
              labelClass: "",
              labelDescription: "",
              placeHolder: "Select document type",
              name: constants.INPUT_ID_ADMIN_DOCUMENT_TYPE,
              required: true,
              type: constants.INPUT_TYPE_DROPDOWN,
              options: [
                {
                  id: "DNI",
                  label: "Document Identification",
                  value: "DNI"
                },
                {
                  id: "PAS",
                  label: "Passport",
                  value: "PAS"
                },
                {
                  id: "DL",
                  label: "Drivers License",
                  value: "DL"
                }
              ],
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid document type."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_ADMIN_DOCUMENT_NUMBER,
              label: "Identification Document Number",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_ADMIN_DOCUMENT_NUMBER,
              placeHolder: "1234563321",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_NUMBERS,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid ID number."
                },
                {
                  type: constants.VALIDATOR_DOCUMENT_NUMBER_BY_DOC_TYPE,
                  errorMessage: "Document number should be between minLength and maxLength characters long.",
                  data: {
                    docTypeFieldId: constants.INPUT_ID_ADMIN_DOCUMENT_TYPE
                  }
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_ADMIN_PHONE,
              label: "Phone",
              labelDescription: "Include the country code (e.g., 56).",
              labelClass: "",
              name: constants.INPUT_ID_ADMIN_PHONE,
              options: [],
              placeHolder: "56930305680",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "15",
              customHandler: constants.INPUT_HANDLER_ONLY_NUMBERS,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid phone."
                },
                {
                  type: constants.VALIDATOR_MAX_LENGTH,
                  errorMessage: "Phone exceeds the maximum of 15 characters allowed",
                  data: {
                    maxLength: 15
                  }
                },
                {
                  type: constants.VALIDATOR_MIN_LENGTH,
                  errorMessage: "Phone must be at least 5 characters long",
                  data: {
                    minLength: 5
                  }
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_ADMIN_EMAIL,
              label: "Email",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_ADMIN_EMAIL,
              placeHolder: "E.g. contact@info.com",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_EMAIL,
                  errorMessage: "Enter a valid email."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: "confirmAdminEmail",
              label: "Confirm Email",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: "confirmAdminEmail",
              placeHolder: "E.g. contact@info.com",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_EMAIL,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_CONFIRMATION_FIELD_VALUE,
                  errorMessage: "The email does not match.",
                  data: {
                    sourceFieldId: constants.INPUT_ID_ADMIN_EMAIL
                  }
                }
              ]
            }
          ]
        },
        {
          id: "2-3",
          title: "Shipping warehouse contact",
          subTitle: "",
          enabled: false,
          showNavigation: true,
          navigationButtonId: AdobeAnalyticsButtonTags[2].shipmentWHContact,
          onRenderActions: {
            subTitle: {
              handler: "RenderSubTitle",
              params: {
                renderSubtitleWith: []
              }
            }
          },
          onNavigateActions: {
            next: {
              handler: constants.ACTION_HANDLER_RENDER_SUBTITLE_AND_FOCUS_SUBSECTION,
              params: {
                nextSubSection: "2-4",
                renderSubtitleWith: [constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_NAME]
              }
            },
            previous: ""
          },
          fields: [
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_NAME,
              label: "Full Name",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_NAME,
              placeHolder: "E.g. John Smith",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "99",
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_SPACES,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid name."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_PHONE,
              label: "Phone",
              labelDescription: "Include the country code (e.g., 56).",
              labelClass: "",
              name: constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_PHONE,
              options: [],
              placeHolder: "56930305680",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "15",
              customHandler: constants.INPUT_HANDLER_ONLY_NUMBERS,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid phone."
                },
                {
                  type: constants.VALIDATOR_MAX_LENGTH,
                  errorMessage: "Phone exceeds the maximum of 15 characters allowed",
                  data: {
                    maxLength: 15
                  }
                },
                {
                  type: constants.VALIDATOR_MIN_LENGTH,
                  errorMessage: "Phone must be at least 5 characters long",
                  data: {
                    minLength: 5
                  }
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_EMAIL,
              label: "Email",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_EMAIL,
              placeHolder: "E.g. contact@info.com",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_EMAIL,
                  errorMessage: "Enter a valid email."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: "confirmShipmentWarehouseContactEmail",
              label: "Confirm Email",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              name: "confirmShipmentWarehouseContactEmail",
              placeHolder: "E.g. contact@info.com",
              required: true,
              type: constants.INPUT_TYPE_TEXT,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_EMAIL,
                  errorMessage: "Enter a valid email."
                },
                {
                  type: constants.VALIDATOR_CONFIRMATION_FIELD_VALUE,
                  errorMessage: "The email does not match.",
                  data: {
                    sourceFieldId: constants.INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_EMAIL
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      section: {
        id: 3,
        title: "Addresses",
        isActive: true,
        stepperNumber: 3,
        stepperLabel: "Addresses",
        type: "Accordion",
        activeSubSection: "3-1",
        itShouldHideAccordionNavigators: true
      },
      subSections: [
        {
          id: "3-1",
          title: "Commercial office address",
          subTitle: "",
          enabled: true,
          showNavigation: true,
          navigationButtonId: AdobeAnalyticsButtonTags[3].businessAddress,
          onRenderActions: {
            subTitle: {
              handler: "RenderSubTitle",
              params: {
                renderSubtitleWith: [],
                subtitleSeparator: ", "
              }
            }
          },
          onNavigateActions: {
            next: {
              handler: constants.ACTION_HANDLER_RENDER_SUBTITLE_AND_FOCUS_SUBSECTION,
              params: {
                nextSubSection: "3-2",
                renderSubtitleWith: [],
                subtitleSeparator: ", "
              }
            },
            previous: ""
          },
          autofill: {
            message: "Use this information for all contacts.",
            affectedSections: ["3-2"],
            behavior: {
              regionShipmentWarehouse: "regionHeadOffice",
              cityShipmentWarehouse: "cityHeadOffice",
              municipalShipmentWarehouse: "municipalHeadOffice"
            }
          },
          fields: [
            {
              class: "search-icon",
              containerClass: "",
              id: constants.INPUT_ID_COUNTRY_SELLER,
              label: "Country",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              required: true,
              name: constants.INPUT_ID_COUNTRY_SELLER,
              options: [],
              placeHolder: "Select an option",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dependencyField: "countryOfRegId",
              disabled: true,
              dataSource: {
                type: constants.DATASOURCE_TYPE_GLOBAL_VALUE,
                params: [
                  {
                    name: "country",
                    sourceType: "GlobalStateValue",
                    sourceId: "registrationCountry"
                  }
                ]
              },
              validators: []
            },
            {
              class: "search-icon",
              containerClass: "",
              id: constants.INPUT_ID_REGION_SELLER,
              label: "State",
              labelEn: "",
              labelClass: "",
              labelByRegistrationCountry: true,
              labelDescription: "",
              required: true,
              name: constants.INPUT_ID_REGION_SELLER,
              options: [],
              placeHolder: "Select an option",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dependencyField: constants.INPUT_ID_COUNTRY_SELLER,
              dataSource: {
                type: constants.DATASOURCE_TYPE_API,
                source: constants.SERVICE_BFF,
                endpoint: "regions",
                params: [
                  {
                    name: "countryCode",
                    sourceType: "GlobalStateValue",
                    sourceId: "registrationCountry"
                  }
                ]
              },
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                },
                {
                  type: constants.VALIDATOR_VALID_OPTION,
                  errorMessage: "Select a valid option."
                }
              ]
            },
            {
              class: "search-icon",
              containerClass: "",
              id: constants.INPUT_ID_CITY_SELLER,
              label: "City",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              labelByRegistrationCountry: true,
              required: true,
              name: constants.INPUT_ID_CITY_SELLER,
              options: [],
              placeHolder: "Select an option",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dependencyField: constants.INPUT_ID_REGION_SELLER,
              dataSource: {
                type: constants.DATASOURCE_TYPE_API,
                source: constants.SERVICE_BFF,
                endpoint: "city",
                params: [
                  {
                    name: "regionId",
                    sourceType: "GlobalStateValue",
                    sourceId: constants.INPUT_ID_REGION_SELLER
                  }
                ]
              },
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                },
                {
                  type: constants.VALIDATOR_VALID_OPTION,
                  errorMessage: "Select a valid option."
                }
              ]
            },
            {
              class: "search-icon",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_MUNICIPAL_SELLER,
              label: "District",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              labelByRegistrationCountry: true,
              required: true,
              name: constants.INPUT_ID_MUNICIPAL_SELLER,
              options: [],
              placeHolder: "Select an option",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dependencyField: constants.INPUT_ID_CITY_SELLER,
              dataSource: {
                type: constants.DATASOURCE_TYPE_API,
                source: constants.SERVICE_BFF,
                endpoint: "municipal",
                params: [
                  {
                    name: "cityId",
                    sourceType: "GlobalStateValue",
                    sourceId: constants.INPUT_ID_CITY_SELLER
                  }
                ]
              },
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                },
                {
                  type: constants.VALIDATOR_VALID_OPTION,
                  errorMessage: "Select a valid option."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              dataSource: "",
              default: "",
              fakeValue: "",
              id: constants.INPUT_ID_ADDRESS_SELLER,
              label: "Address",
              labelEn: "Address",
              labelClass: "",
              labelDescription: "",
              required: true,
              name: constants.INPUT_ID_ADDRESS_SELLER,
              options: [],
              placeHolder: "E.g. 123 Main street, Apartment 101",
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "120",
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter an address."
                },
                {
                  type: constants.VALIDATOR_MAX_LENGTH,
                  errorMessage: "Enter an address with max. 120 characters.",
                  data: {
                    maxLength: 120
                  }
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              dataSource: "",
              default: "",
              fakeValue: "",
              id: constants.INPUT_ID_POSTALCODE_SELLER,
              label: "Zip code / Postal Code",
              labelEn: "Zip code / Postal Code",
              labelClass: "",
              labelDescription: "",
              required: true,
              name: constants.INPUT_ID_POSTALCODE_SELLER,
              options: [],
              placeHolder: "E.g. 7500008",
              type: constants.INPUT_TYPE_TEXT,
              maxLength: "10",
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a Zip Code / Postal Code."
                },
                {
                  type: constants.VALIDATOR_IS_NUMERIC,
                  errorMessage: "Only numbers are allowed."
                },
                {
                  type: constants.VALIDATOR_MAX_LENGTH,
                  errorMessage: "Enter an Zip Code / Postal Code with max. 10 characters.",
                  data: {
                    maxLength: 10
                  }
                }
              ]
            }
          ]
        },
        {
          id: "3-2",
          title: "Shipping Warehouse",
          subTitle: "",
          enabled: false,
          showNavigation: true,
          navigationButtonId: AdobeAnalyticsButtonTags[3].shipmentWH,
          onRenderActions: {
            subTitle: {
              handler: "RenderSubTitle",
              params: {
                renderSubtitleWith: [],
                subtitleSeparator: ", "
              }
            }
          },
          onNavigateActions: {
            next: {
              handler: constants.ACTION_HANDLER_RENDER_SUBTITLE_AND_FOCUS_SUBSECTION,
              params: {
                nextSubSection: "3-3",
                renderSubtitleWith: [
                  constants.INPUT_ID_ADDRESS_SHIPMENT_WH,
                  constants.INPUT_ID_MUNICIPAL_SHIPMENT_WH,
                  constants.INPUT_ID_REGION_SHIPMENT_WH
                ],
                subtitleSeparator: ", "
              }
            },
            previous: ""
          },
          fields: [
            {
              class: "search-icon",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_COUNTRY_SHIPMENT_WH,
              label: "Country",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              required: true,
              name: constants.INPUT_ID_COUNTRY_SHIPMENT_WH,
              options: [],
              placeHolder: "Select an option",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dependencyField: "registrationCountry",
              disabled: true,
              dataSource: {
                type: constants.DATASOURCE_TYPE_GLOBAL_VALUE,
                params: [
                  {
                    name: "country",
                    sourceType: "GlobalStateValue",
                    sourceId: "registrationCountry"
                  }
                ]
              },
              validators: []
            },
            {
              class: "search-icon",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_REGION_SHIPMENT_WH,
              label: "State",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              labelByRegistrationCountry: true,
              required: true,
              name: constants.INPUT_ID_REGION_SHIPMENT_WH,
              options: [],
              placeHolder: "Select an option",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dependencyField: constants.INPUT_ID_COUNTRY_SHIPMENT_WH,
              dataSource: {
                type: constants.DATASOURCE_TYPE_API,
                source: constants.SERVICE_BFF,
                endpoint: "regions",
                params: [
                  {
                    name: "countryCode",
                    sourceType: "GlobalStateValue",
                    sourceId: "registrationCountry"
                  }
                ]
              },
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                },
                {
                  type: constants.VALIDATOR_VALID_OPTION,
                  errorMessage: "Select a valid option."
                }
              ]
            },
            {
              class: "search-icon",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_CITY_SHIPMENT_WH,
              label: "City",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              labelByRegistrationCountry: true,
              required: true,
              name: constants.INPUT_ID_CITY_SHIPMENT_WH,
              options: [],
              placeHolder: "Select an option",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dependencyField: constants.INPUT_ID_REGION_SHIPMENT_WH,
              dataSource: {
                type: constants.DATASOURCE_TYPE_API,
                source: constants.SERVICE_BFF,
                endpoint: "city",
                params: [
                  {
                    name: "regionId",
                    sourceType: "GlobalStateValue",
                    sourceId: constants.INPUT_ID_REGION_SHIPMENT_WH
                  }
                ]
              },
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                },
                {
                  type: constants.VALIDATOR_VALID_OPTION,
                  errorMessage: "Select a valid option."
                }
              ]
            },
            {
              class: "search-icon",
              containerClass: "",
              default: "",
              id: constants.INPUT_ID_MUNICIPAL_SHIPMENT_WH,
              label: "District",
              labelEn: "",
              labelClass: "",
              labelDescription: "",
              labelByRegistrationCountry: true,
              required: true,
              name: constants.INPUT_ID_MUNICIPAL_SHIPMENT_WH,
              options: [],
              placeHolder: "Select an option",
              type: constants.INPUT_TYPE_SEARCH_SELECT,
              dependencyField: constants.INPUT_ID_CITY_SHIPMENT_WH,
              dataSource: {
                type: constants.DATASOURCE_TYPE_API,
                source: constants.SERVICE_BFF,
                endpoint: "municipal",
                params: [
                  {
                    name: "cityId",
                    sourceType: "GlobalStateValue",
                    sourceId: constants.INPUT_ID_CITY_SHIPMENT_WH
                  }
                ]
              },
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                },
                {
                  type: constants.VALIDATOR_VALID_OPTION,
                  errorMessage: "Select a valid option."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              dataSource: "",
              default: "",
              fakeValue: "",
              id: constants.INPUT_ID_ADDRESS_SHIPMENT_WH,
              label: "Address",
              labelEn: "Address",
              labelClass: "",
              labelDescription: "",
              required: true,
              name: constants.INPUT_ID_ADDRESS_SHIPMENT_WH,
              options: [],
              placeHolder: "E.g. 123 Main street",
              type: constants.INPUT_TYPE_ADDRESS_MAP,
              requiredFields: [
                constants.INPUT_ID_COUNTRY_SHIPMENT_WH,
                constants.INPUT_ID_REGION_SHIPMENT_WH,
                constants.INPUT_ID_CITY_SHIPMENT_WH,
                constants.INPUT_ID_MUNICIPAL_SHIPMENT_WH
              ],
              references: {
                country: constants.INPUT_ID_COUNTRY_SHIPMENT_WH,
                region: constants.INPUT_ID_REGION_SHIPMENT_WH,
                city: constants.INPUT_ID_CITY_SHIPMENT_WH,
                municipal: constants.INPUT_ID_MUNICIPAL_SHIPMENT_WH,
                coordinates: constants.INPUT_ID_COORDINATES_SHIPMENT_WH
              },
              maxLength: "120",
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter an address."
                },
                {
                  type: constants.VALIDATOR_MAX_LENGTH,
                  errorMessage: "Enter an address with max. 120 characters.",
                  data: {
                    maxLength: 120
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      section: {
        id: 4,
        title: "Disclaimers and conditions",
        isActive: true,
        stepperNumber: 4,
        stepperLabel: "Disclaimers",
        type: "Accordion",
        activeSubSection: "4-1"
      },
      subSections: [
        {
          id: "4-1",
          title: "Compliance",
          subTitle: "",
          enabled: true,
          showNavigation: true,
          navigationButtonId: AdobeAnalyticsButtonTags[4].conflictInterest,
          onRenderActions: {
            subTitle: {
              handler: "RenderSubTitle",
              params: {
                renderSubtitleWith: [],
                subtitleSeparator: ", "
              }
            }
          },
          onNavigateActions: {
            next: {
              handler: constants.ACTION_HANDLER_FOCUS_SUBSECTION,
              params: {
                nextSubSection: "4-2"
              }
            },
            previous: ""
          },
          fields: [
            {
              id: "complianceDeclarationNotice",
              labelClass: "p-compliance-declaration",
              default: `Before completing this section, please read our <a href="/docs/DeclarationOfCompliance.pdf" class="rdb_label_link" target="_blank">Declaration of Compliance</a>.`,
              type: constants.INPUT_TYPE_CUSTOM_HTML
            },
            {
              containerClass: "",
              dataSource: "",
              default: "",
              id: "conflictOfInterest",
              labelMandatory: "",
              label: "Conflict of interest",
              labelClass: "lbl-title-strong ",
              labelDescription: "Is there a conflict of interest with anyone from Falabella, Sodimac, or Linio?",
              name: "conflictOfInterest",
              options: [
                {
                  id: "conflictOfInterest_1",
                  value: constants.SI,
                  label: "Yes",
                  labelClass: "rdb_label",
                  onClickActions: [
                    {
                      handler: constants.ACTION_HANDLER_TOGGLE_VISIBILITY,
                      params: {
                        fieldsToToggle: ["personNameWithConflictOfInterest", "typeOfConflict"],
                        action: "show"
                      }
                    }
                  ]
                },
                {
                  id: "conflictOfInterest_2",
                  value: constants.NO,
                  label: "No",
                  labelClass: "rdb_label",
                  onClickActions: [
                    {
                      handler: constants.ACTION_HANDLER_TOGGLE_VISIBILITY,
                      params: {
                        fieldsToToggle: ["personNameWithConflictOfInterest", "typeOfConflict"],
                        action: "hide"
                      }
                    }
                  ]
                }
              ],
              placeHolder: "",
              required: true,
              type: constants.INPUT_TYPE_RADIO,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              default: "",
              id: "personNameWithConflictOfInterest",
              label: "What is the full name of the person in your company?",
              labelClass: "",
              labelDescription: "",
              name: "personNameWithConflictOfInterest",
              placeHolder: "Ej. John Smith",
              isHidden: true,
              required: false,
              type: constants.INPUT_TYPE_TEXT,
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_SPACES,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a name.",
                  ifIsChecked: "conflictOfInterest_1"
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              dataSource: "",
              default: "",
              fakeValue: "",
              id: "typeOfConflict",
              label: "What is the relationship that person has with someone in the Falabella Group?",
              labelClass: "",
              labelDescription: "",
              name: "typeOfConflict",
              options: [
                {
                  id: "typeOfConflict_1",
                  label: "By kinship",
                  value: "De parentesco"
                },
                {
                  id: "typeOfConflict_2",
                  label: "By friendship",
                  value: "De amistad"
                },
                {
                  id: "typeOfConflict_3",
                  label: "By property",
                  value: "De propiedad"
                },
                {
                  id: "typeOfConflict_4",
                  label: "From previous professional relationships",
                  value: "De relaciones profesionales previas"
                },
                {
                  id: "typeOfConflict_5",
                  label: "Others",
                  value: "Otros"
                }
              ],
              placeHolder: "Select an option",
              required: false,
              isHidden: true,
              type: constants.INPUT_TYPE_DROPDOWN,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option.",
                  ifIsChecked: "conflictOfInterest_1"
                }
              ]
            },
            {
              containerClass: "",
              dataSource: "",
              default: "",
              id: "hasPepRelationship",
              labelMandatory: "",
              label: "Politically Exposed Person",
              labelClass: "lbl-title-strong ",
              labelDescription: "Is any relevant executive from your company a PEP (Politically Exposed Person)?",
              name: "hasPepRelationship",
              options: [
                {
                  id: "hasPepRelationship_1",
                  value: constants.SI,
                  label: "Yes",
                  labelClass: "rdb_label",
                  onClickActions: [
                    {
                      handler: constants.ACTION_HANDLER_TOGGLE_VISIBILITY,
                      params: {
                        fieldsToToggle: ["pepName", "relationshipWithPep"],
                        action: "show"
                      }
                    }
                  ]
                },
                {
                  id: "hasPepRelationship_2",
                  value: constants.NO,
                  label: "No",
                  labelClass: "rdb_label",
                  onClickActions: [
                    {
                      handler: constants.ACTION_HANDLER_TOGGLE_VISIBILITY,
                      params: {
                        fieldsToToggle: ["pepName", "relationshipWithPep"],
                        action: "hide"
                      }
                    }
                  ]
                }
              ],
              placeHolder: "",
              required: true,
              type: constants.INPUT_TYPE_RADIO,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              dataSource: "",
              default: "",
              id: "pepName",
              label: "What is the full name of the person in your company?",
              labelClass: "",
              labelDescription: "",
              name: "pepName",
              placeHolder: "Eg. John Smith",
              required: false,
              isHidden: true,
              type: constants.INPUT_TYPE_TEXT,
              customHandler: constants.INPUT_HANDLER_ONLY_LETTERS_AND_SPACES,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter a name.",
                  ifIsChecked: "hasPepRelationship_1"
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              dataSource: "",
              default: "",
              id: "relationshipWithPep",
              label: "What is the relationship that the Politically Exposed Person (PEP) has?",
              labelClass: "",
              labelDescription: "",
              isHidden: true,
              name: "relationshipWithPep",
              options: [
                {
                  id: "relationshipWithPep_1",
                  label: "Grandparent",
                  value: "Abuelo"
                },
                {
                  id: "relationshipWithPep_2",
                  label: "Father",
                  value: "Padre"
                },
                {
                  id: "relationshipWithPep_3",
                  label: "Mother",
                  value: "Madre"
                },
                {
                  id: "relationshipWithPep_4",
                  label: "Myself",
                  value: "Yo mismo"
                },
                {
                  id: "relationshipWithPep_5",
                  label: "Sibling",
                  value: "Hermano(a)"
                },
                {
                  id: "relationshipWithPep_6",
                  label: "Child",
                  value: "Hijo(a)"
                },
                {
                  id: "relationshipWithPep_7",
                  label: "Grandchild",
                  value: "Nieto"
                }
              ],
              placeHolder: "",
              required: false,
              type: constants.INPUT_TYPE_DROPDOWN,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option.",
                  ifIsChecked: "hasPepRelationship_1"
                }
              ]
            },
            {
              containerClass: "",
              dataSource: "",
              default: "",
              id: "crimePrevention",
              labelMandatory: "",
              label: "Crime prevention and fair competition",
              labelClass: "lbl-title-strong ",
              labelDescription: "",
              name: "crimePrevention",
              options: [
                {
                  id: "crimePrevention_1",
                  value: constants.NO,
                  label:
                    "I declare that neither I, nor any relevant executive person of the company, has ever been charged with and/or investigated, indicted, charged or convicted of any of the offenses or actions described in the Declaration of Compliance.",
                  labelClass: "rdb_label",
                  onClickActions: [
                    {
                      handler: constants.ACTION_HANDLER_TOGGLE_VISIBILITY,
                      params: {
                        fieldsToToggle: ["crimePreventionObservation"],
                        action: "hide"
                      }
                    }
                  ]
                },
                {
                  id: "crimePrevention_2",
                  value: constants.SI,
                  label: "I have doubts with this field, I prefer to leave an observation.",
                  labelClass: "rdb_label",
                  onClickActions: [
                    {
                      handler: constants.ACTION_HANDLER_TOGGLE_VISIBILITY,
                      params: {
                        fieldsToToggle: ["crimePreventionObservation"],
                        action: "show"
                      }
                    }
                  ]
                }
              ],
              placeHolder: "",
              required: true,
              type: constants.INPUT_TYPE_RADIO,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Select an option."
                }
              ]
            },
            {
              class: "",
              containerClass: "",
              dataSource: "",
              default: "",
              id: "crimePreventionObservation",
              label: "Observation",
              labelClass: "",
              labelDescription: "",
              name: "crimePreventionObservation",
              placeHolder: "Enter your comment so we can analyze the case.",
              required: false,
              isHidden: true,
              type: constants.INPUT_TYPE_TEXT,
              validators: [
                {
                  type: constants.VALIDATOR_NOT_EMPTY,
                  errorMessage: "Enter an observation.",
                  ifIsChecked: "crimePrevention_2"
                }
              ]
            }
          ]
        },
        {
          id: "4-2",
          title: "Terms and conditions",
          subTitle: "",
          enabled: false,
          showNavigation: true,
          navigationButtonId: AdobeAnalyticsButtonTags[4].personExpPol,
          onRenderActions: {
            subTitle: {
              handler: "RenderSubTitle",
              params: {
                renderSubtitleWith: [],
                subtitleSeparator: ", "
              }
            }
          },
          onNavigateActions: {
            next: {
              handler: constants.ACTION_HANDLER_FOCUS_SUBSECTION,
              params: {
                nextSubSection: "4-3"
              }
            },
            previous: ""
          },
          fields: [
            {
              class: "cb_checkbox",
              containerClass: " terms-and-conditions",
              id: "termsAndConditions",
              labelClass: "",
              labelMandatory: "",
              labelDescription: "",
              name: "termsAndConditions",
              value: constants.SI,
              required: true,
              placeHolder: "I accept ",
              labelLink: {
                url: "/docs/TermsAndConditions.pdf",
                text: "terms and conditions",
                target: "_blank",
                class: "rdb_label_link"
              },
              type: constants.INPUT_TYPE_CHECKBOX,
              validators: [
                {
                  type: constants.VALIDATOR_IS_CHECKED,
                  errorMessage: "You must accept the terms and conditions."
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  successPage: {
    title: "Congratulations, we have received your registration form!",
    description: [
      `You've done your part, now it's our turn. Soon we will contact you at %userEmail%.`,
      `If you have any doubts, you can email us at ${intlConstants.SUPPORT_EMAIL}`
    ],
    buttonShow: false,
    buttonText: null,
    buttonLink: null,
    textReplacedFromForm: {
      "%userEmail%": [constants.INPUT_ID_ADMIN_EMAIL, constants.INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL]
    }
  }
};

export default FormConfig;
